import React from 'react'

export default function UserRow(props){
    const {name} = props
    return (<>
    <div className='mobile-user-participating'>
        {name}
    </div>
    </>)
}